<template>
  <div class="notification-toast-container">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="notification-toast"
      :class="toast.type"
      role="alert"
    >
      <div class="notification-toast-content">
        <h4 class="notification-toast-title">{{ toast.message }}</h4>
      </div>
      <button
        type="button"
        class="notification-toast-close"
        @click="removeToast(toast.id)"
        aria-label="Close"
      >
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useToast } from '@/composables/useToast';

const { toasts, remove } = useToast();

function removeToast(id) {
  remove(id);
}
</script>

<style scoped>
.notification-toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 400px;
  pointer-events: none;
}

.notification-toast {
  background: white;
  border-radius: var(--radius-md, 8px);
  padding: 16px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  animation: slideIn 0.3s ease-out;
  min-width: 300px;
  border-left: 4px solid #ccc;
  pointer-events: auto;
}

.notification-toast.success {
  border-left-color: var(--secondary-color, #6DD4C7);
  background: linear-gradient(to right, rgba(109, 212, 199, 0.1) 0%, white 20%);
}

.notification-toast.error {
  border-left-color: #FF6B6B;
  background: linear-gradient(to right, rgba(255, 107, 107, 0.1) 0%, white 20%);
}

.notification-toast.warning {
  border-left-color: #FFD43B;
  background: linear-gradient(to right, rgba(255, 212, 59, 0.1) 0%, white 20%);
}

.notification-toast.info {
  border-left-color: #7B8FD4;
  background: linear-gradient(to right, rgba(123, 143, 212, 0.1) 0%, white 20%);
}

.notification-toast-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notification-toast-title {
  font-weight: 600;
  font-size: 14px;
  color: #2d3748;
  margin: 0;
}

.notification-toast-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #718096;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  transition: color 0.2s;
  flex-shrink: 0;
}

.notification-toast-close:hover {
  color: #2d3748;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
